import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getReport } from "../../../redux/services/reportSlice";
import Overview from "./Overview";
import Analysis from "./analysis";
import Compare from "./compare";
import Summary from "./summary";
import Elimination from "./elimination";
import Leaderboard from "./leaderBoard";

const ViewResult = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const queryParams = new URLSearchParams(location.search);
  const qaId = queryParams.get("qaId");
  const contestId = queryParams.get("contestId");
  const getReportData = useSelector((state) => state?.report?.reportData);
  const [activeTab, setActiveTab] = useState("tab1");
  console.log(contestId);
  
  const getReports = useCallback(async () => {
    try {
      await dispatch(getReport({ qaId: qaId, contestId: contestId }));
    } catch (error) {}
  }, [dispatch, qaId, contestId]);

  useEffect(() => {
    getReports();
  }, [getReports]);
  const tabs = [
    { key: "tab1", label: "Overview Content" },
    { key: "tab2", label: "AI Powered Report Analysis" },
    { key: "tab3", label: "Summary" },
    { key: "tab4", label: "Compare Competitor" },
    { key: "tab5", label: "Elimination Skill Report" },
    { key: "tab6", label: "All India Rank List" },
  ];
  return (
    <div className="mx-auto bg-white shadow-lg rounded-xl p-6 min-h-full">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          View Result
        </h2>
        <button className="flex items-center gap-3 rounded-lg px-2 py-2 text-md uppercase text-white bg-[#124699] hover:bg-opacity-90 border-2 border-[#124699]" onClick={()=>navigate(`/view-solution?qaId=${qaId}&contestId=${contestId}`)}>
          <p className="font-semibold">View Solution</p>
        </button>
      </div>
      <div className="flex flex-wrap gap-2 lg:gap-4 border-b pb-4 ">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-3 py-2 flex justify-center  font-semibold text-md items-center rounded-md transition duration-300 ${
              activeTab === tab.key
                ? "bg-[#124699] text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="mt-4">
        {activeTab === "tab1" && (
          <Overview overviewReportData={getReportData?.sec1} />
        )}
        {activeTab === "tab2" && (
          <Analysis analysisData={getReportData?.sec1?.polity?.qaTypeMetrics} subjectData={getReportData?.sec3?.subjectWiseReport}/>
        )}
        {activeTab === "tab3" && (
          <Summary summaryData={getReportData.sec2.qaTypeStrategyReport} subWiseData={getReportData.sec1.qaSubtopicSummary}/>
        )}
        {activeTab === "tab4" && (
          <Compare
            compareData={getReportData.sec2.compareWithCompetitor}
            compareSubWiseData={getReportData.sec2.subtopicWiseReport}
            compareStrategyWiseData={
              getReportData.sec3.qaTypeStrategyWiseComparison
            }
          />
        )}
        {activeTab === "tab5" && (
          <Elimination eliminationData={getReportData.sec3.eliminationReport} />
        )}
        {activeTab === "tab6" && <Leaderboard contestId={contestId} qaId={qaId}/>}
      </div>
    </div>
  );
};

export default ViewResult;
